import shapeCertificate from '../assets/icons/shapeCertificate.svg';
import { svgToIcon } from '../utils/svg';
import PolygonBase from './PolygonBase';

class ShapeCertificate extends PolygonBase {
  static preparedControls: ReturnType<
    typeof PolygonBase.connectControlDefinition
  >;

  calcTextMargin() {
    const { height, width } = this.fabricObject;

    const verticalBound = height / 5;
    const horizontalBound = width / 5;

    return {
      top: verticalBound,
      left: horizontalBound,
      right: horizontalBound,
      bottom: verticalBound,
    };
  }

  // A star is radially distributed points alternating on inner and outer circles
  static pathString() {
    const numPoints = 24;
    const angle = Math.PI / numPoints;
    const outerRadius = 0.5;
    const innerRadius = 0.4;
    const points: [number, number][] = [];

    for (let i = 0; i < 2 * numPoints; i++) {
      const radius = (i & 1) === 0 ? outerRadius : innerRadius;

      const pointX = Math.cos(i * angle) * radius;
      const pointY = Math.sin(i * angle) * radius;

      points.push([pointX, pointY]);
    }

    // Prepare the controls while we have the geometry loaded.
    const controls = { ...super.connectControlDefinition() };
    // Add the outer radius points (evens) as connectors
    for (let i = 0; i < points.length; i += 2) {
      // skip adding the cardinal/standard points
      if ([0, 12, 24, 36].includes(i)) {
        continue;
      }
      controls[`certificate_${i}`] = {
        x: points[i][0],
        y: points[i][1],
        normal: { x: points[i][0] * 2, y: points[i][1] * 2 },
      };
    }

    this.preparedControls = controls;

    // Write the SVG path connecting the points that alternately lie on circles
    let path = `M ${points.shift()}\n`;
    points.forEach(point => (path += `L ${point}\n`));
    path += 'Z';

    return path;
  }

  static connectControlDefinition() {
    return this.preparedControls;
  }

  static renderIcon() {
    return svgToIcon(shapeCertificate);
  }

  // smooth continuous outline for edge attachment
  static edgePathString() {
    return `
      M 0.5 0
      a 0.5,0.5 0 0,1 -1,0
      a 0.5,0.5 0 0,1 1,0
      Z
    `;
  }
}

export default ShapeCertificate;
